import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, ReferenceLine, CartesianGrid } from "recharts";

const Dot = ({ cx, cy, payload, selected, onSelect }) => {
  if (cx == null || cy == null) return null;
  const on = payload.n === selected;
  return (
    <circle cx={cx} cy={cy} r={on ? 7 : 4} fill={on ? "#FF2A2A" : "#9333EA"} stroke="#fff" strokeWidth={on ? 2 : 1}
      style={{ cursor: "pointer" }} onClick={() => onSelect(payload.n, false)} data-testid={`altitude-dot-${payload.n}`} />
  );
};

export function AltitudeChart({ survey, selected, onSelect }) {
  const data = survey.points.filter((p) => p.alt != null).map((p) => ({ n: p.n, alt: p.alt, filename: p.filename }));
  if (!data.length) {
    return <p className="text-sm text-neutral-500 border-2 border-black p-4" data-testid="altitude-chart-empty">No altitude recorded in these photos.</p>;
  }
  return (
    <div className="border-2 border-black p-3 bg-white" data-testid="altitude-chart">
      <p className="label-mono mb-2">ALTITUDE (M, AS RECORDED) · CAPTURE SEQUENCE</p>
      <div className="h-56">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 8, right: 16, bottom: 4, left: -8 }}
            onClick={(e) => e?.activePayload?.[0] && onSelect(e.activePayload[0].payload.n, false)}>
            <CartesianGrid stroke="rgba(255,255,255,0.08)" strokeDasharray="2 4" />
            <XAxis dataKey="n" tick={{ fontFamily: "IBM Plex Mono, monospace", fontSize: 11 }} stroke="#94A3B8" />
            <YAxis tick={{ fontFamily: "IBM Plex Mono, monospace", fontSize: 11 }} stroke="#94A3B8" domain={["auto", "auto"]} />
            <Tooltip contentStyle={{ border: "1px solid rgba(0,242,254,0.4)", borderRadius: 10, background: "#0B0F17", color: "#E2E8F0", fontFamily: "IBM Plex Mono, monospace", fontSize: 11 }}
              formatter={(v) => [`${v} m`, "ALT"]} labelFormatter={(n) => `#${n} · ${data.find((d) => d.n === n)?.filename || ""}`} />
            {survey.alt_avg != null && <ReferenceLine y={survey.alt_avg} stroke="#22D3EE" strokeDasharray="4 4" label={{ value: `AVG ${survey.alt_avg}`, fontSize: 10, fill: "#22D3EE", position: "insideTopLeft" }} />}
            {survey.alt_max != null && <ReferenceLine y={survey.alt_max} stroke="#FF2A2A" strokeDasharray="4 4" label={{ value: `MAX ${survey.alt_max}`, fontSize: 10, fill: "#FF2A2A", position: "insideTopRight" }} />}
            <Line type="monotone" dataKey="alt" stroke="#00F2FE" strokeWidth={2} isAnimationActive={false}
              dot={(props) => <Dot key={props.payload.n} {...props} selected={selected} onSelect={onSelect} />} activeDot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
